import { render } from "./S124154.vue?vue&type=template&id=5e114aa2"
const script = {}
script.render = render

export default script